"use client";

// Perekam ID Klik iklan (`fbclid` → cookie first-party) di BROWSER.
//
// Kenapa modul sendiri, bukan ikut `pixelClient.ts`/`platformPixelClient.ts`
// yang sengaja terpisah: pemisahan itu soal REGISTRY vendor aktif (satu
// singleton salah-set = pixel toko menembak di situs platform). Perekam ini
// tak punya state apa pun — ia hanya menyalin satu parameter URL ke cookie —
// jadi satu salinan bersama justru mencegah dua implementasi menyimpang.
//
// Guard-nya sengaja HANYA production: cookie ini tak mengirim apa pun ke
// siapa pun, dan halaman pendaratan iklan bisa halaman mana saja (termasuk
// yang pixel-nya tak menembak). Yang memutuskan memakainya tetap route
// server, dan di sana `_fbc` asli selalu menang.

import { FBC_FALLBACK_COOKIE, FBC_FALLBACK_MAX_AGE_SEC, buildFbcFromFbclid } from "@/lib/pixel";

/**
 * Rekam `fbclid` dari URL pendaratan sebagai cookie `mh_fbc`.
 *
 * Meta Pixel menulis `_fbc` sendiri — TAPI justru saat fbevents.js diblokir
 * ad-blocker/ITP (alasan Conversions API ada) cookie itu tak pernah lahir, dan
 * event server kehilangan satu-satunya penghubung ke klik iklan yang
 * membayarnya. Kode aplikasi sendiri tetap jalan di sana; salinan inilah yang
 * menambalnya.
 *
 * Klik BARU menimpa yang lama: Meta mengatribusi ke klik TERAKHIR sebelum
 * konversi, bukan first-touch (berbeda dari `recordOrderAttribution`).
 *
 * Tanpa `fbclid` di URL = tanpa tulis — kunjungan organik tidak boleh
 * menghapus ID Klik dari kunjungan iklan sebelumnya.
 */
export function captureAdClickId(): void {
  try {
    if (typeof window === "undefined") return;
    if (process.env.NODE_ENV !== "production") return;
    const fbclid = new URLSearchParams(window.location.search).get("fbclid");
    const fbc = buildFbcFromFbclid(fbclid, Date.now());
    if (!fbc) return;
    document.cookie =
      `${FBC_FALLBACK_COOKIE}=${encodeURIComponent(fbc)}` +
      `; path=/; max-age=${FBC_FALLBACK_MAX_AGE_SEC}; samesite=lax; secure`;
  } catch {
    /* pelacakan tak boleh mengganggu halaman */
  }
}
